











































import { Result, ResultSortCriteria, ResultSortCriteriaIdEnum } from '@empathybroker/tsclient-search';

import { ColorEnum } from '../../enums';

import Badge from '../badge.component.vue';
import ExplainResultsRow from './explain-results-row.component.vue';

export default {
  name: 'explain-results-tiebreakers-row',
  props: {
    results: {
      type: Array,
      required: true
    },
    messages: {
      type: Object,
      required: true
    }
  },
  components: {
    ExplainResultsRow,
    Badge
  },
  computed: {
    resultIds: function (): string[] {
      return this.results.map((result: Result) => result.id);
    },
    tiebreakersLabel: function (): string {
      return ((this.results.length === 1) ? this.messages.label : this.messages.abbr);
    },
    tiebreakerIds: function (): string[] {
      return this.results.reduce((tiebreakersIds: string[], result: Result) => {
        const resultTiebreakers = this.getResultTiebreakers(result);
        resultTiebreakers.forEach((tiebreaker: ResultSortCriteria) => {
          if (!tiebreakersIds.includes(tiebreaker.id)) {
            tiebreakersIds.push(tiebreaker.id);
          }
        });
        return tiebreakersIds;
      }, []);
    }
  },
  data: function () {
    return {
      childrenExpanded: false,
      ColorEnum
    };
  },
  methods: {
    getResultTiebreakers: function (result: Result): ResultSortCriteria[] {
      return result.debug.sort.filter((sortCriteria: ResultSortCriteria) =>
        (sortCriteria.id !== ResultSortCriteriaIdEnum.SCORE));
    },
    getResultTiebreakerValueText: function (result: Result, tiebreakerId: string): string {
      const resultTiebreaker = this.getResultTiebreakers(result)
        .find((tiebreaker: ResultSortCriteria) => (tiebreaker.id === tiebreakerId));
      let valueText: string;
      if (!!resultTiebreaker) {
        valueText = resultTiebreaker.value;
        if (!isNaN(resultTiebreaker.value)) {
          valueText = this.$epb.utils.formatNumber(Number(valueText), { maximumFractionDigits: 2 });
        }
      }
      return (valueText || '-');
    }
  }
};
